export default "__VITE_ASSET__e3e424be__"